const URL = (process.env.NODE_ENV === 'production') ? 'https://tgckapi.ddtmx.com/' : 'https://tgckapi.ddtmx.com/';
export default URL;